if (typeof SizeFinder !== "function") {
  
  class SizeFinder extends HTMLElement {
    constructor() {
      super();
    }
    round5(x) {
      return Math.round(x/5)*5;
    }
    normalizeSize(value) {
      return value == null ? "" : value.toString().trim();
    }
    getMatchSize = (bw, srl, map) => {
      if (!Array.isArray(map)) return undefined;

      let matchSize = map.find(item => parseFloat(item.bw) == parseFloat(bw) && parseFloat(item.srl) == parseFloat(srl))

      if (!matchSize) {
        let newBw = Math.round(bw)
        let newSRL = this.round5(srl * 10) / 10

        matchSize = map.find(item => parseFloat(item.bw) == newBw && parseFloat(item.srl) == newSRL)
      }
      return matchSize
    }
    getSizeMap(sizeSystem) {
      return sizeSystem === "INCH" ? window.inchSizeMap : window.konfSizeMap;
    }
    getTranslatedSize(size, sourceSystem) {
      if (!Array.isArray(window.sizeMap)) return undefined;

      const sourceKey = sourceSystem === "INCH" ? "inch" : "size";
      const targetKey = sourceSystem === "INCH" ? "size" : "inch";
      const normalizedSize = this.normalizeSize(size);
      const translated = window.sizeMap.find(item => this.normalizeSize(item[sourceKey]) === normalizedSize);

      return translated ? translated[targetKey] : undefined;
    }
    showNotFound() {
      this.output?.classList.add("visible");
      if (this.outputText) {
        this.outputText.textContent = this.dataset.sizeNotFound || window.themeVariables?.strings?.sizeFinderNotFound || "";
      }
      requestAnimationFrame(() => this.output?.focus());
    }
    renderResult(sizeSystem, size, translatedSize) {
      const isInch = sizeSystem === "INCH";
      const primaryLabel = isInch ? this.dataset.labelInch : this.dataset.labelDe;
      const secondaryLabel = isInch ? this.dataset.labelDe : this.dataset.labelInch;

      this.col1.textContent = primaryLabel || (isInch ? "Inch" : "DE");
      this.val1.textContent = this.normalizeSize(size);
      this.col2.textContent = translatedSize == null ? "" : secondaryLabel || (isInch ? "DE" : "Inch");
      this.val2.textContent = this.normalizeSize(translatedSize);
      if (this.status) {
        const resultHeading = this.resultHeading?.textContent.trim();
        const primaryResult = `${this.col1.textContent}: ${this.val1.textContent}`;
        const secondaryResult = this.col2.textContent && this.val2.textContent ? `${this.col2.textContent}: ${this.val2.textContent}` : "";
        this.status.textContent = [resultHeading, primaryResult, secondaryResult].filter(Boolean).join(". ");
      }
    }
    getProductVariantElement() {
      const formId = this.dataset.formId;
      if (formId) {
        const scopedVariantElement = document.querySelector(`product-variants[form-id="${formId}"]`);
        if (scopedVariantElement) return scopedVariantElement;
      }

      const variantElements = document.querySelectorAll("product-variants");
      return variantElements.length === 1 ? variantElements[0] : null;
    }
    getProductFormContainer() {
      const formId = this.dataset.formId;
      const form = formId ? document.getElementById(formId) : null;
      return form ? form.closest(".product-form") : null;
    }
    _onSubmitForm(event, target) {
      event.preventDefault();

      const bwInput = this.querySelector('.input-bw');
      const srlInput = this.querySelector('.input-srl');
      if (!bwInput || !srlInput || !bwInput.value || !srlInput.value) return false;

      const bw = parseFloat(bwInput.value.replace(",", "."));
      const srl = parseFloat(srlInput.value.replace(",", "."));
      if (!Number.isFinite(bw) || !Number.isFinite(srl) || bw <= 0 || srl <= 0) {
        this.showNotFound();
        return false;
      }

      const productSizeSystem = this.dataset.sizeSystem === "INCH" ? "INCH" : "DE";
      let matchedSizeSystem = productSizeSystem;
      let matchSize = this.getMatchSize(bw, srl, this.getSizeMap(productSizeSystem));

      if (!matchSize) {
        matchedSizeSystem = productSizeSystem === "INCH" ? "DE" : "INCH";
        matchSize = this.getMatchSize(bw, srl, this.getSizeMap(matchedSizeSystem));
      }

      if (!matchSize) {
        this.showNotFound();
        return false;
      }

      const matchedSize = matchSize.size;
      const translatedSize = this.getTranslatedSize(matchedSize, matchedSizeSystem);
      const productSize = matchedSizeSystem === productSizeSystem ? matchedSize : translatedSize;
      const secondarySize = matchedSizeSystem === productSizeSystem ? translatedSize : matchedSize;

      if (productSize == null) {
        this.showNotFound();
        return false;
      }

      this.popupForm.classList.add("hidden");
      this.result.classList.add("active");
      this.output?.classList.remove("visible");
      this.renderResult(productSizeSystem, productSize, secondarySize);
      this.sizeAtc.textContent = this.normalizeSize(productSize);

      const normalizedProductSize = this.normalizeSize(productSize);
      const sizeFinderVariants = Array.isArray(window.sizeFinderVariants) ? window.sizeFinderVariants : [];
      const variant = sizeFinderVariants.find(item =>
        this.normalizeSize(item.option1) === normalizedProductSize && item.available
      );

      this.selectedVariant = variant || null;
      if (this.atc) this.atc.style.display = variant ? "block" : "none";
      requestAnimationFrame(() => this.result?.focus());

      return false;
    }
    getFocusableElements() {
      if (!this.popup) return [];
      return Array.from(this.popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => {
        const style = window.getComputedStyle(element);
        return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
      });
    }
    handleKeydown = (event) => {
      if (!this.isOpen) return;
      if (event.key === "Escape") {
        event.preventDefault();
        this.closePopup();
        return;
      }
      if (event.key !== "Tab") return;

      const focusableElements = this.getFocusableElements();
      if (focusableElements.length === 0) {
        event.preventDefault();
        this.popup?.focus();
        return;
      }
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && (document.activeElement === firstFocusableElement || !this.contains(document.activeElement))) {
        event.preventDefault();
        lastFocusableElement.focus();
      } else if (!event.shiftKey && (document.activeElement === lastFocusableElement || !this.contains(document.activeElement))) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
    handleOpen = (event) => {
      const requestedFormId = event.detail && event.detail.formId;
      if (requestedFormId && requestedFormId !== this.dataset.formId) return;
      this.openPopup(event.detail && event.detail.triggerElement);
    }
    openPopup(triggerElement = null) {
      if (this.isOpen) return;
      this.isOpen = true;
      window.sizeFinderOpened = true;
      this.previouslyFocusedElement = triggerElement || document.activeElement;
      this.inert = false;
      this.setAttribute("aria-hidden", "false");
      this.classList.remove('hidden');
      document.body.classList.add("overflow-hidden");
      this.result.classList.remove("active");
      this.popupForm.classList.remove("hidden");
      this.output?.classList.remove("visible");
      if (this.status) this.status.textContent = "";
      clearTimeout(this.backgroundOpenTimer);
      clearTimeout(this.popupOpenTimer);
      clearTimeout(this.focusTimer);
      this.backgroundOpenTimer = setTimeout(() => {
        this.background?.classList.add('visible');
      }, 100)

      this.popupOpenTimer = setTimeout(() => {
        this.popup?.classList.add('visible');
      }, 200)

      this.focusTimer = setTimeout(() => {
        this.inputBW?.focus();
        this.inputBW?.select();
      }, 220);
    }
    closePopup() {
      if (!this.isOpen) return;
      this.isOpen = false;
      document.body.classList.remove("overflow-hidden");
      window.sizeFinderOpened = false;
      clearTimeout(this.backgroundOpenTimer);
      clearTimeout(this.popupOpenTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.backgroundCloseTimer);
      clearTimeout(this.popupCloseTimer);
      if (this.video) {
        this.video.pause();
      }
      this.popup?.classList.remove('visible');
      this.backgroundCloseTimer = setTimeout(() => {
        this.background?.classList.remove('visible');
      }, 100)

      const focusReturnElement = this.previouslyFocusedElement;
      this.previouslyFocusedElement = null;
      if (focusReturnElement && focusReturnElement.isConnected && typeof focusReturnElement.focus === "function") {
        focusReturnElement.focus();
      }
      this.setAttribute("aria-hidden", "true");
      this.inert = true;
      this.popupCloseTimer = setTimeout(() => {
        this.classList.add('hidden')
      }, 700);
    }
    connectedCallback() {
      const $this = this
      this.form = this.querySelector(".size-finder")
      this.popupForm = this.querySelector(".ds-size-finder__popup-form");
      this.result = this.querySelector(".ds-size-finder__result")
      this.resultHeading = this.result?.querySelector(".ds-size-finder__popup-form-header")
      this.status = this.querySelector(".ds-size-finder__status")
      this.isOpen = false;
      this.inert = true;
      this.form?.addEventListener("submit", this._onSubmitForm.bind(this));
      this.background = this.querySelector('.ds-size-finder__background');
      this.output = this.querySelector(".ds-size-finder__output");
      this.outputText = this.querySelector(".ds-size-finder__output-text");
      this.popup = this.querySelector('.ds-size-finder__popup');
      this.inputBW = this.querySelector('.input-bw');
      this.close = this.querySelector(".ds-size-finder__popup-close");
      this.val1 = this.querySelector(".ds-size-finder__result-val1")
      this.val2 = this.querySelector(".ds-size-finder__result-val2")
      this.sizeAtc = this.querySelector(".ds-size-finder__result-atc")
      this.atc =  this.querySelector(".ds-size-finder__result-actions button")
      this.sizeFinderCartForm = this.querySelector(".ds-size-finder__cart-form")
      this.video = this.querySelector('.ds-size-finder__video')

      this.col1 = this.querySelector(".ds-size-finder__result-col1")
      this.col2 = this.querySelector(".ds-size-finder__result-col2")

      this.close?.addEventListener('click', () => this.closePopup())
      this.background?.addEventListener('click', () => this.closePopup())


      this.sizeFinderCartForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!$this.selectedVariant) return false;

        const productVariantElement = $this.getProductVariantElement();
        if (productVariantElement) {
          productVariantElement.extSelectVariant($this.selectedVariant.id);
        }

        if ($this.selectedVariant.option1) {
          const sizeInfo = $this.getProductFormContainer()?.querySelector('.ds-select-size .select__selected-value');
          if (sizeInfo) {
            const sizeLabel = window.themeVariables?.strings?.productSizeLabel;
            sizeInfo.textContent = sizeLabel ? `${sizeLabel}: ${$this.selectedVariant.option1}` : $this.selectedVariant.option1;
          }
        }

        this.sizeFinderCartForm.querySelector('[name="id"]').value = $this.selectedVariant.id

        try {
          const productForm = new FormData(this.sizeFinderCartForm);
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: productForm,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          const cartContent = await response.json();

          $this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: response.ok ? "success" : "error",
              error: cartContent.description || ""
            }
          }));

          if (!response.ok) return false;

          $this.closePopup();
          const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`, { cache: "reload" });
          const cart = await cartResponse.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:open"));
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              detail: { cart },
              bubbles: true
            }));
          }, 100);
        } catch (error) {
          $this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: "error",
              error: error instanceof Error ? error.message : ""
            }
          }));
        }

        return false;
      })

      this.checkbox = this.querySelector(".input-size-type");
      if (this.checkbox) {
        this.checkbox.addEventListener('click', () => {
          if (this.checkbox.checked) {
            $this.querySelector(".input-bw").placeholder = $this.querySelector(".input-bw").getAttribute('data-inch-placeholder');
            $this.querySelector(".input-srl").placeholder = $this.querySelector(".input-srl").getAttribute('data-inch-placeholder');
          } else {
            $this.querySelector(".input-bw").placeholder = $this.querySelector(".input-bw").getAttribute('data-cm-placeholder');
            $this.querySelector(".input-srl").placeholder = $this.querySelector(".input-srl").getAttribute('data-cm-placeholder');
          }
        });
      }

      this.querySelector(".ds-size-finder__result-back")?.addEventListener("click", () => {
        this.result.classList.remove("active");
        this.popupForm.classList.remove("hidden");
        this.output?.classList.remove("visible");
        requestAnimationFrame(() => this.inputBW?.focus());
      });

      window.addEventListener('product:size-finder', this.handleOpen)
      window.addEventListener('keydown', this.handleKeydown);
      let params = new URL(document.location).searchParams;
      if (params.get('size-finder')) {
        this.openPopup();
      }
    }
    disconnectedCallback() {
      window.removeEventListener('product:size-finder', this.handleOpen);
      window.removeEventListener('keydown', this.handleKeydown);
      clearTimeout(this.backgroundOpenTimer);
      clearTimeout(this.popupOpenTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.backgroundCloseTimer);
      clearTimeout(this.popupCloseTimer);
      if (this.isOpen) {
        document.body.classList.remove("overflow-hidden");
        window.sizeFinderOpened = false;
      }
    }
  }

  if (typeof customElements.get("size-finder") == "undefined") {
    customElements.define("size-finder", SizeFinder);
  }
}
